import React from 'react';
import { PhoneIcon, ArrowRightIcon } from 'lucide-react';
export function MobileStickyCTA() {
  return <div className="fixed bottom-0 left-0 right-0 z-40 md:hidden" data-id="element-365">
      <div className="bg-white border-t border-warm-200 shadow-[0_-4px_12px_rgba(0,0,0,0.08)] px-4 py-3 flex gap-3" data-id="element-366">
        <a href="tel:817-581-1419" className="flex items-center justify-center gap-2 flex-1 py-3 bg-navy-950 text-white font-bold text-sm rounded-lg hover:bg-navy-900 transition-colors focus:outline-none focus:ring-2 focus:ring-navy-950 focus:ring-offset-2" aria-label="Call NTA Taekwondo" data-id="element-367">
          <PhoneIcon className="w-4 h-4" data-id="element-368" />
          Call Now
        </a>
        <a href="#cta" className="flex items-center justify-center gap-2 flex-1 py-3 bg-amber text-navy-950 font-bold text-sm rounded-lg hover:bg-amber-light transition-colors focus:outline-none focus:ring-2 focus:ring-amber focus:ring-offset-2" data-id="element-369">
          Free Week
          <ArrowRightIcon className="w-4 h-4" data-id="element-370" />
        </a>
      </div>
    </div>;
}